<template>
    <div>
        <el-drawer
            title="导入批量退款"
            :visible.sync="visible"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
        >
            <div class="drawer-content">
                <el-upload
                    drag
                    action
                    :http-request="uploadExcel"
                    :auto-upload="false"
                    ref="upload"
                    accept=".xls, .xlsx"
                    :show-file-list="true"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :on-change="onChange"
                    :on-remove="onRemove"
                    :disabled="uploadLoading">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                    <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且最多不超过5000行</div>
                </el-upload>
                
                <div class="color-info">
                    导入文件示例如下:
                    <el-button 
                        type="text" 
                        icon="el-icon-download" 
                        @click="download">
                        点击下载模板
                    </el-button>
                </div>

                <div class="temp-table">
                    <el-table
                        :data="tempModel"
                        style="width: 100%"
                        size="small"
                        border
                    >
                        <el-table-column prop="activityId" label="演出ID" :min-width="150"></el-table-column>
                        <el-table-column prop="orderId" label="订单编号" :min-width="150"></el-table-column>
                        <el-table-column prop="refundAmountFormat" label="退款金额" :min-width="150"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit"
                    >提交</el-button>
            </div>

            <ErrorMsgDrawer ref="errorMsgDrawer"></ErrorMsgDrawer>     

        </el-drawer>
    </div>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';
import ErrorMsgDrawer from '@/components/ErrorMsgDrawer';
export default {
    props: {
        id: {
            type: [Number, String],
            default: '',
        },
    },
    components:{ErrorMsgDrawer},
    data(){
        return{
            visible:false,
            btnLoading:false,
            downLoading:false,
            uploadLoading:false,
            tempModel:[{
                activityId:'1123',
                orderId:'xdyc183823884365',
                refundAmountFormat:'100.00'
            },{
                activityId:'1123',
                orderId:'xdyc183823884365',
                refundAmountFormat:'100.00'
            }],
            canSubmit:true,
            fileList:[],
            // errMsgShow:false,
            // errMsgList:[]
        }
    },
    methods:{
        show() {
            this.visible = true;
        },
        close(){
            this.fileList = [];
            this.$refs.upload.clearFiles();
            this.visible = false;
        },
        //下载模板
        async download(){

            let filePath;

            this.downLoading = true;

            const res = await this.$request({
                url:'/activity/refund/downloadTemp',
                method: 'post',
            }).catch(err => {
                this.$message({message: err.message, type: 'error'});
            })

            const{state,msg,result:{url}} = res.data;

            if(state == 1 &&  url){
                filePath = url;
            }else{
                this.downLoading = false;
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'演出批量退款.'+this.$utils.getFileType(filePath));

            this.downLoading = false;
        },
        onSubmit(){
            this.$refs.upload.submit();
        },
        async uploadExcel(req){
            this.btnLoading = true;
            this.uploadLoading = true;
            const formData = new FormData();
            formData.append('file', req.file);

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            }).finally(() => {
                this.uploadLoading = false;
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.$message.error(msg || '上传失败');
            }

            this.$request({
                url:'/activity/refund/batch/import',
                method: 'post',
                params:{path:filePath}
            })
                .then(res => {
                    const{state,msg,result} = res.data;
                    if (state == 1) {
                        if(result && result.importErrorDetailVOList){
                            this.$refs.errorMsgDrawer.show(result);
                        }else{
                            this.onSuccess();
                        }
                        
                    }else{
                        this.$message.error(msg || '上传失败');
                        this.canSubmit = false;
                    }
                })
                .catch(err => {
                    this.canSubmit = false;
                    this.$message({message: err.message, type: 'error'});
                })
                .finally(() => {
                    this.btnLoading = false;
                    this.canSubmit = true;
                });
        },
        beforeUpload(file){
            const type = this.$utils.getFileType(file.name)
            const isType = type === 'xls' || type === 'xlsx';
            if (!isType) {
                this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
            }
            return isType;
        },
        onSuccess(){
            this.$emit('onUpdate');
            this.close();
        },
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
                this.canSubmit = false;
            }else{
                this.canSubmit = true;
            }
        },
        onRemove(){
            this.canSubmit = true;
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-theme;
    }
}
</style>